export default {
  en: {
    agentType: 'Agent Type',
    keyword: 'Keyword',
    type: 'Type',
    description: 'Description',
    newAgentType: 'New Agent Type',
    confirmRemoveAgentTypeMessage: 'Confirm to delete <strong>{name}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeAgentTypeSuccess: 'Remove Agent Type success'
  },
  th: {
    agentType: 'ประเภทตัวแทน',
    keyword: 'คำค้นหา',
    type: 'ประเภท',
    description: 'รายละเอียด',
    newAgentType: 'เพิ่มประเภทตัวแทน',
    confirmRemoveAgentTypeMessage: 'กรุณายืนยันการลบ <strong>{name}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeAgentTypeSuccess: 'Remove sale person success'
  }
}
